module.exports = __webpack_public_path__ + "img/P20-en.21f53499.png";